/*eslint-disable */
export default {
    init() {
        // JavaScript to be fired on all pages

        getMobileMenu();
        getStickyMenu();
        getSlideshowOne();

        function getSlideshowOne() {
            $('.section .slideshow').slick({
                arrows: true,
                infinite: false,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            arrows: false,
                            dots: false
                        }
                    },
                ]
            });
        }

        function getMobileMenu() {
            var slideRight = new Menu({
                wrapper: '#o-wrapper',
                type: 'slide-right',
                menuOpenerClass: '.c-button',
                maskId: '#c-mask',
            });

            var slideRightBtn = document.querySelector('#c-button--slide-right');

            slideRightBtn.addEventListener('click', function (e) {
                e.preventDefault;
                slideRight.open();
            });
        }

        function getStickyMenu() {
            var w = window;
            var d = document;
            var el_html = d.documentElement,
                el_body = d.getElementsByTagName('body')[0],
                header = d.getElementById('o-wrapper'),
                menuIsStuck = function () {
                    var wScrollTop = w.pageYOffset || el_body.scrollTop,
                        regexp = /(nav\-is\-stuck)/i,
                        classFound = el_html.className.match(regexp),
                        navHeight = header.offsetHeight,
                        bodyRect = el_body.getBoundingClientRect(),
                        scrollValue = 0;
                    if (wScrollTop > scrollValue && !classFound) {
                        el_html.className = el_html.className + ' nav-is-stuck';
                        el_body.style.paddingTop = '0';
                    }
                    if (wScrollTop < 2 && classFound) {
                        el_html.className = el_html.className.replace(regexp, '');
                        el_body.style.paddingTop = '0';
                    }
                    if (wScrollTop < 2 && classFound) {
                        el_html.className = el_html.className.replace(regexp, '');
                        el_body.style.paddingTop = '0';
                    }
                },
                onScrolling = function () {
                    menuIsStuck();
                };

            w.addEventListener('scroll', function () {
                w.requestAnimationFrame(onScrolling);
            });
        }
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js